import React from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";

import {formAdapter} from "../../utils";
import {errorToast, successToast} from "../../../../../shared/toastify";
import {baseUrl} from "../../../../../constants/constants";
import {ITags} from "../../../../public/NewsPage/news";


export interface IPublishNews {
    name: string;
    description: string;
    source_link: string;
    dzen_link: string;
    tg_link: string;
    image: FileList | null;
    create_date: Date;
    tags_id: { [key: string]: boolean };
}

interface Props {
    close: () => void;
    tags: ITags[];
}

const PublishNewsForm = ({ tags, close }: Props) => {
    const defaultSelectedTagId = tags.find((tag) => tag.name === "Все новости")?.id;

    const {
        register,
        handleSubmit,
        formState: { errors },
        setError,
        control,
    } = useForm<IPublishNews>({
        defaultValues: {
            tags_id: {
                ...(defaultSelectedTagId && {[defaultSelectedTagId]: true})
            },
        },
    });

    const handleChange = (event: { target: { files: any } }) => {
        console.log(event.target.files);
    };

    const submit: SubmitHandler<IPublishNews> = async (data: any) => {
        try {
            const selectedTags = Object.values(data.tags_id).some((isSelected) => isSelected);
            if (!selectedTags) {
                setError("tags_id", { type: "manual", message: "Выберите хотя бы один тег" });
                return;
            }

            const adaptedData = formAdapter(data, tags);
            console.log("Преобразованные данные:", adaptedData);

            const isoDate = new Date(data.create_date).toISOString();

            const formData = new FormData();

            formData.append("name", adaptedData.name);
            formData.append("description", adaptedData.description);
            formData.append("source_link", adaptedData.source_link);
            formData.append("dzen_link", adaptedData.dzen_link);
            formData.append("tg_link", adaptedData.tg_link);
            formData.append("image", data.image[0]);
            formData.append("create_date", isoDate);
            // formData.append("tags_id", JSON.stringify(adaptedData.tags_id));
            adaptedData.tags_id.forEach((value) => formData.append('tags_id', value.toString()))

            const res = await fetch(`${baseUrl}news`, {
                method: "POST",
                body: formData,
            });

            if (res.status === 200) {
                successToast("Новость опубликована");
                close();
            } else if (res.status === 401) {
                setError("root", { type: "custom", message: "" });
                errorToast("Ошибка");
            }
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <form className="regForm" onSubmit={handleSubmit(submit)}>
            <input
                type="text"
                className="regInput"
                placeholder="Заголовок новости"
                {...register("name", {required: true})}
            />
            {errors.name && <p className="wrong-message">Это поле обязательно</p>}

            <textarea
                className="regInput"
                placeholder="Текст новости (если его нет - нажми пробел)"
                {...register("description", {required: true})}
            />

            <input
                type="text"
                className="regInput"
                placeholder="Ссылка на вк"
                {...register("source_link", {required: true})}
            />
            {errors.source_link && <p className="wrong-message">Это поле обязательно</p>}

            <input
                type="text"
                className="regInput"
                placeholder="Ссылка на Дзен"
                {...register("dzen_link")}
            />

            <input
                type="text"
                className="regInput"
                placeholder="Ссылка на Телеграм"
                {...register("tg_link")}
            />

            <span className="regInput__file">
                <p>Изображение записи</p>
                <input
                    type="file"
                    {...register("image", {required: true})}
                    accept="image/jpg, image/jpeg, image/webp, image/png"
                />
            </span>
            {errors.image && <p className="wrong-message">Это поле обязательно</p>}

            <label className="regLabel">
                Дата публикации
                <input
                    type="date"
                    className="regInput"
                    {...register("create_date", {required: true})}
                />
            </label>

            <fieldset className="account-label">
                Теги
                {tags.map((i) => (
                    <span key={i.id}>
                        <Controller
                            name={`tags_id.${i.id}`}
                            control={control}
                            defaultValue={false}
                            render={({field}) => (
                                <input
                                    type="checkbox"
                                    className="regInput__checkbox-galka"
                                    checked={field.value}
                                    onChange={(e) => field.onChange(e.target.checked)}
                                />
                            )}
                        />
            <label className="account-label__radio__label">{i.name}</label>
        </span>
                ))}
            </fieldset>
            <button className="button form-btn">Опубликовать</button>
        </form>
    );
};

export default PublishNewsForm;